export const EnterpriseBreadCrumbSchema = {
  "@context": "https://schema.org/",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://onsitego.com/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "landingpage",
      item: "https://onsitego.com/landingpage",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Enterprise Device Care Solutions | Warranty & Damage Protection | Onsitego",
      item: "https://onsitego.com/landingpage/enterprise",
    },
  ],
};

export const EnterpriseOrganizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Onsitego",
  url: "https://onsitego.com/",
  logo: "https://d2js0267gg4oqb.cloudfront.net/_next/static/media/onsite-logo-inverse.8190a3419a1359a4a0b5ff4aa42b6dfe.png",
  sameAs: [
    "https://facebook.com/onsitego",
    "https://twitter.com/onsitego",
    "https://www.instagram.com/onsitego/",
    "https://www.youtube.com/c/Onsitego_official",
    "https://www.linkedin.com/company/onsitego",
  ],
};


export const DEVICES = [
  {
    text: "1-50 devices",
    value: "1-50 devices",
    key: 1,
  },
  {
    text: "51-200 devices",
    value: "51-200 devices",
    key: 2,
  },
  {
    text: "201-500 devices",
    value: "201-500 devices",
    key: 3,
  },
  {
    text: "500+ devices",
    value: "500+ devices",
    key: 4,
  },
];

export const DEVICE_TYPES = [
  {
    text: "Laptops",
    value: "Laptops",
    key: 1,
  },
  {
    text: "Phones/Tablets",
    value: "Phones/Tablets",
    key: 2,
  },
  {
    text: "Mixed Devices",
    value: "Mixed Devices",
    key: 3,
  },
  {
    text: "Other",
    value: "Other",
    key: 4,
  },
];
